/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowSquareIn: {
  name: 'arrow_square_in';
  data: string;
} = {
  name: 'arrow_square_in',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M6.75 3a1.5 1.5 0 0 0-1.5 1.5V9a.75.75 0 0 0 1.5 0V4.5H19.5v12.75H15a.75.75 0 1 0 0 1.5h4.5a1.5 1.5 0 0 0 1.5-1.5V4.5A1.5 1.5 0 0 0 19.5 3H6.75Z" fill="currentColor"/><path d="M4.125 13.5a.75.75 0 0 1 .75-.75H10.5a.75.75 0 0 1 .75.75l.001 5.625a.75.75 0 0 1-1.5 0v-3.814l-5.472 5.472a.75.75 0 0 1-1.061-1.06l5.472-5.472-3.814-.001a.75.75 0 0 1-.75-.75Z" fill="currentColor"/></svg>`
};
